import { Button, Dialog } from "@mui/material";
import React, { useState } from "react";
import styles from "../../styles/components/modalWrapper.module.scss";
// import Image from "next/image";
import assest from "../../json/assest";

const ModalWrapperVideoAssets = (props) => {
  const { open, onClose, children,handleClose } = props;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="modalWrappervideoAssetsModal"

    >
        <Button className="cross_btn" onClick={handleClose}>
            <img src={assest.crossGray} alt="img" width={9} height={9}/>
        </Button>
      {children}
    </Dialog>
  );
};

export default ModalWrapperVideoAssets;